<div class="modal" class:is-active={isShown} class:is-clipped={isShown}>
  <div class="modal-background" />
  <div class="modal-content">
    <slot />
  </div>
</div>


<script>
import store, { STATES_MAIN, STATES_FIRST_VISIT } from "../../state";
// html vars
let isShown = true;
store.subscribe(state => {
    isShown =
        state.currentState ===
            `${STATES_MAIN.FIRST_VISIT}.${STATES_FIRST_VISIT.DEFAULT}` ||
            state.tncAcccepted === false;
});
</script>


<style>.modal{justify-content:flex-start}.modal .modal-background{background-color:#363636;opacity:1}.modal .modal-content{width:295px;top:15%}</style>
